<template>
  <div class="fertilizer">
    <div class="box">
      <img src="./bucket1.jpg" width="432" height="432" alt="I Has a Bucket">
      <img src="./bucket2.jpg" width="432" height="432" alt="Noooo they be stealin' my Bucket">
    </div>
    <div class="updated">29 III 2006</div>
  </div>
</template>

<script>
export default {
  name: "Bucket"
};
</script>

<style scoped>
.fertilizer {
  background-color: #000;
}

.box {
  margin-top: -216px;
  width: 432px;
  margin-left: -216px;
  left: 50%;
  position: relative;
}

img {
  position: absolute;
  left: 0;
  top: 0;
}

@keyframes bucket {
  0% {
    opacity: 0;
  }

  20% {
    opacity: 0;
  }

  30% {
    opacity: 1;
  }

  70% {
    opacity: 1;
  }

  80% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

img:last-child {
  animation-duration: 5s;
  animation-name: bucket;
  animation-iteration-count: infinite;
}

.updated {
  color: #fff;
}
</style>